"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEVEL_TO_SYSLOG = void 0;
exports.addPinoSyslogFormatter = addPinoSyslogFormatter;
exports.setSyslogDefault = setSyslogDefault;
exports.syslogLevelFormatter = syslogLevelFormatter;
var _Levels = require("./Levels");
/**
 * A table mapping pino levels to [syslog
 * levels](https://en.wikipedia.org/wiki/Syslog#Severity_level). Used by
 * {@link syslogLevelFormatter}, so you shouldn't need to use it directly.
 */
const LEVEL_TO_SYSLOG = exports.LEVEL_TO_SYSLOG = {
  [_Levels.FastackLogLevel.FATAL]: 2,
  [_Levels.FastackLogLevel.ERROR]: 3,
  [_Levels.FastackLogLevel.WARN]: 4,
  [_Levels.FastackLogLevel.INFO]: 6,
  [_Levels.FastackLogLevel.DEBUG]: 7,
  [_Levels.FastackLogLevel.TRACE]: 7
};
let SYSLOG_DEFAULT = 4;

/**
 * Sets the default syslog level used when an unrecognized or nonexistent pino
 * level is passed in.
 *
 * This is process-wide state currently, mostly because it has no known
 * use-cases right now.
 */
function setSyslogDefault(level) {
  SYSLOG_DEFAULT = level;
}

/**
 * A value suitable to pass to
 * [pino](https://github.com/pinojs/pino/tree/main)'s `formatters.level`.
 * Returns an object with `level` unchanged and `syslogLevel` obtained from
 * {@link LEVEL_TO_SYSLOG}.
 *
 * Unrecognized levels use syslog level 4 (warn), but this can be changed
 * globally with {@link setSyslogDefault}.
 *
 * You can use {@link addPinoSyslogFormatter} to automatically merge this into a
 * pino config under `formatters.level`, so you may not need to reference this
 * directly.
 */
function syslogLevelFormatter(_label, level) {
  const syslogLevel = LEVEL_TO_SYSLOG[level] ?? SYSLOG_DEFAULT;
  return {
    syslogLevel,
    level
  };
}

/**
 * Add {@link syslogLevelFormatter} as `formatters.level` to a pino config and
 * return the mutated config. This will preserve existing formatters and merge
 * with the return of an existing `formatters.level` function.
 *
 * We use this to help with DataDog integration, specifically their [log status
 * remapper](https://docs.datadoghq.com/logs/log_configuration/processors/?tab=ui#log-status-remapper).
 *
 * @example
 * ```
 * import pino from "pino";
 *
 * const log = pino(addPinoSyslogFormatter({
 *   level: "info",
 *   formatters: {
 *     bindings: () => ({serverId: process.env.SERVER_ID}),
 *   },
 * }));
 * log.info("Hi!"); // contains level, syslogLevel, serverId, ...
 * ```
 */
function addPinoSyslogFormatter(pinoConfig = {}) {
  pinoConfig.formatters = pinoConfig.formatters ?? {};
  const origLevel = pinoConfig.formatters.level ?? (() => ({}));
  pinoConfig.formatters.level = (label, level) => {
    return {
      ...syslogLevelFormatter(label, level),
      ...origLevel(label, level)
    };
  };
  return pinoConfig;
}
//# sourceMappingURL=Syslog.js.map